<template>
  <div class="row">
    <div class="col-lg-8 col-xl-9 order-lg-1">
      <app-frame>
        <template v-if="lazyload">
          <div class="video-lazy-wrapper ratio ratio-16x9">
            <div class="video-wrapper" :class="{ initialized: false, 'non-interactive': false }">
              <video
                :id="`video-container-${video.id}`"
                class="video-js no-preview"
                preload="none"
                :poster="poster"
                crossorigin="anonymous"
                playsinline
                :muted="true"
              />
            </div>
          </div>
        </template>
        <player
          v-else
          :id="`hero-${video.id}`"
          ratio="16x9"
          :source="video.hls_url"
          :poster="poster"
          :subtitles-en="video.subtitles_en || undefined"
          :subtitles-de="video.subtitles_de || undefined"
          :subtitles-fr="video.subtitles_fr || undefined"
          :cast="false"
        />
      </app-frame>
      <div class="video-label" v-html="t(`In our journey we've met <b>892 models</b>, made <b>6390+ videos</b> and had countless orgasms`)" />
    </div>
    <div class="description-block col-lg-4 col-xl-3 order-lg-0">
      <h1 class="main-title">
        {{ video[`title_${locale}`] }}
      </h1>
      <p>{{ video[`hero_description_${locale}`] }}</p>

      <div class="d-flex justify-content-center justify-content-lg-start">
        <button v-modal.modal-signup class="btn btn-primary wide hero-join" @click="sendRegistrationTrack">
          {{ ctaLabel || t("Join Now") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, PropType } from "vue";
import { useI18n } from "vue-i18n";
import AppFrame from "@/components/v2/app-frame/index.vue";
import { getFreeareaVideoPoster } from "@/utils/mediaHelper";
import { amplitudeRegistrationButtonClickTrack } from "@/utils/amplitude";
import { FreeareaVideo } from "@/interfaces/Video/FreeareaVideo.ts";

const Player = defineAsyncComponent(() => import("@/components/player/index.vue"));

defineOptions({
  name: "hero-item",
});

const props = defineProps({
  video: {
    type: Object as PropType<FreeareaVideo>,
    required: true,
  },
  ctaLabel: {
    type: String,
    required: false,
    default: null,
  },
});

const { locale, t } = useI18n();
const lazyload = navigator?.userAgent?.includes("GTmetrix");
const poster = getFreeareaVideoPoster(props.video.thumb);

const sendRegistrationTrack = () => {
  amplitudeRegistrationButtonClickTrack("hero");
};
</script>
